export class ContactInformation {
	customerId: number = 0;
	homePhone: string = '';
	workPhone: string = '';
	mobilePhone: string = '';
	smsNotificationsEnabled: boolean = false;
	emailAddress: string = '';
	emailNotificationsEnabled: boolean = false;
	isPaperStatementsOptedIn: boolean = false;
	isEmailStatementsOptedIn: boolean = false;
}
